// cycle the testimonials
const cycleTestimonials = () => {
  const testimonials = document.querySelectorAll(
    "[data-component='testimonials']"
  );

  testimonials.forEach((testimonial) => {
    const quotes = testimonial.querySelectorAll(".quote");

    let current = parseInt(testimonial.getAttribute("data-active")) || 0;

    if (current < quotes.length) {
      current++;
    } else {
      current = 0;
    }

    quotes.forEach((quote, index) => {
      if (index === current) {
        quote.classList.add("active");
      } else {
        quote.classList.remove("active");
      }
    });

    testimonial.setAttribute("data-active", current);
  });
};

cycleTestimonials();

setInterval(() => {
  cycleTestimonials();
}, 5000);
